// IIFE - Immediately Invoked Function Expression
(function($, window, document) {

    // The $ is now locally scoped 

    // Listen for the jQuery ready event on the document
    $(function() {

        // The DOM is ready!

    });


    const whatsappBtns = document.querySelectorAll('.whatsapp-btn');
    const modal = document.getElementById('lead-modal');
    const closeBtn = document.querySelector('.close-btn');
    const leadForm = document.getElementById('lead-form');

    if (whatsappBtns.length > 0) {
      whatsappBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault(); // Evita comportamentos padrão de link se for a tag <a>
          modal.style.display = 'flex';
        });
      });

      
      closeBtn.addEventListener('click', () => {
        modal.style.display = 'none';
      });
    }

    if (modal) {
      window.addEventListener('click', (event) => {
        if (event.target === modal) {
          modal.style.display = 'none';
        }
      });
    }

    /*Wa lead form*/
    if (leadForm) {
        leadForm.addEventListener('submit', async (e) => {
          e.preventDefault();

          const submitBtn = leadForm.querySelector('button[type="submit"]');
          submitBtn.disabled = true;
          submitBtn.innerText = "Processando...";

          const formData = new FormData();
          formData.append('nome', document.getElementById('lead-name').value);
          formData.append('email', document.getElementById('lead-email').value);
          formData.append('telefone', document.getElementById('lead-phone').value);

          try {
            const response = await fetch('capture_lead.php', {
              method: 'POST',
              body: formData
            });

            const result = await response.json();

            if (result.success) {
              // 1. DISPARAR EVENTO PARA O DATALAYER
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({ 'event': 'clique_whatsapp_fl'});

              // 2. ABRIR WHATSAPP EM NOVA ABA
              window.open(result.redirectUrl, '_blank');

              // 3. FECHAR MODAL E RESETAR FORMULÁRIO
              document.getElementById('lead-modal').style.display = 'none';
              leadForm.reset();
            } else {
              alert(result.message || 'Ocorreu um erro ao enviar. Tente novamente.');
            }
          } catch (error) {
            console.error('Erro no envio:', error);
            alert('Ocorreu um erro de conexão. Tente novamente.');
          } finally {
            submitBtn.disabled = false;
            submitBtn.innerText = "Ir para o WhatsApp";
          }
        });    
    } 

    /*read more*/
    var readMoreTrigger = document.getElementsByClassName("-rm-trigger");
    
    var toggleMoreContent = function() {
        //var excerpt = this.parentNode.getElementsByClassName('-rm-excerpt')[0];
        var moreText = this.parentNode.getElementsByClassName('-rm-more');

        for (var i = 0; i < moreText.length; i++) {
          //console.log(this)
          if (moreText[i].classList.contains('-rm-on')) {
            //moreText[i].style.display = "none";
            moreText[i].classList.remove('-rm-on')
            this.classList.remove('-active')
            this.querySelector('span').innerHTML = "Ver mais erros";
          } else {
            //moreText[i].style.display = "flex";
            moreText[i].classList.add('-rm-on')
            this.classList.add('-active')
            this.querySelector('span').innerHTML = "Ver menos";
            
          }
        }
    };

    for (var i = 0; i < readMoreTrigger.length; i++) {
        readMoreTrigger[i].addEventListener('click', toggleMoreContent, false);
    } 


    gsap.registerPlugin(ScrollTrigger);

    const counter = document.querySelectorAll('.count');
    if (counter) {
      counter.forEach(el => {
        const end = parseFloat(el.dataset.end) || 0;
        const proxy = { val: 0 };

        gsap.to(proxy, {
          val: end,
          duration: 2,
          ease: "power2.out",
          onUpdate: () => {
            el.textContent = Math.round(proxy.val).toLocaleString('pt-BR');
          },
          scrollTrigger: {
            trigger: el,
            start: "top 90%",   // quando o elemento chegar a 80% da viewport
            /*toggleActions: "play none none none", */
            toggleActions: "play none none reverse",
            //once: true          // roda só uma vez
          }
        });
      });     
    }

    const typingEl = document.querySelectorAll(".-typing");
    if (typingEl.length > 0) {
      gsap.utils.toArray(".-typing").forEach((text) => {
        //let text = document.querySelector(".-typing");
        let content = text.textContent;
        text.textContent = ""; // clear first
        gsap.to(text, {
          duration: 2.5,
          text: content,  // Requires TextPlugin
          ease: "none"
        });
      });
    }
    // Fade-in sections on scroll
    gsap.utils.toArray(".-fade-in").forEach((secfade) => {
      gsap.from(secfade, {
        opacity: 0,
        y: 100,
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: secfade,
          start: "top 80%",
          toggleActions: "play none none reverse"
        }
      });
    });

    gsap.utils.toArray(".-animate-in").forEach((sec) => {
      /*gsap.to(sec, {
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: "none",
        //ease: "power2.out",
        scrollTrigger: {
          trigger: sec,
          start: "top 80%",
          toggleActions: "play none none reverse"
        }
      });*/
      gsap.from(sec, {
        opacity: 0,
        y: 100,
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: sec,
          start: "top 80%",
          toggleActions: "play none none "
        }
      });
    });

    //scrollspy
    /*document.addEventListener('DOMContentLoaded', function(){ 
      // grab the sections (targets) and menu_links (triggers)
      // for menu items to apply active link styles to
      const sections = document.querySelectorAll(".--spy");
      const menu_links = document.querySelectorAll(".--spy-nav-item a");
      

      // functions to add and remove the active class from links as appropriate
      const makeActive = (link) => menu_links[link].parentElement.classList.add("active");
      const removeActive = (link) => menu_links[link].parentElement.classList.remove("active");
      const removeAllActive = () => [...Array(sections.length).keys()].forEach((link) => removeActive(link));
      
      // change the active link a bit above the actual section
      // this way it will change as you're approaching the section rather
      // than waiting until the section has passed the top of the screen
      const sectionMargin = 100;
      
      // keep track of the currently active link
      // use this so as not to change the active link over and over
      // as the user scrolls but rather only change when it becomes
      // necessary because the user is in a new section of the page
      let currentActive = 0;

      // listen for scroll events
      window.addEventListener("scroll", () => {
        //console.log('k')

        const current = sections.length - [...sections].reverse().findIndex((section) => window.scrollY >= section.offsetTop - sectionMargin ) - 1
        console.log(current)

        // only if the section has changed
        // remove active class from all menu links
        // and then apply it to the link for the current section
        if (current !== currentActive) {
          removeAllActive();
          currentActive = current;
          makeActive(current);

        }
      });
    }, false); */   
    
    //Menu trigger
    var menuTrigger = document.getElementsByClassName("menu-trigger-btn"),
        menu = document.getElementById("main-nav");
    
    var toggleMenu = function() {
    	   //console.log('main nav offcanvas called')
        //menu.classList.toggle("offcanvas-nav-active");
        document.body.classList.toggle("menu-active");
    };

    for (var i = 0; i < menuTrigger.length; i++) {
        menuTrigger[i].addEventListener('click', toggleMenu, false);
    }
  
    
    

    function redirect(goto){
        /*var conf = confirm("Are you sure you want to go elswhere?");
        if (conf && goto != '') {
            window.location = goto;
        }*/
        window.location = goto;
    }
   
    /*Anchor scroll*/
    const anchors = document.querySelectorAll(".scroll-anchor");
     
    for (const anchor of anchors) {
      anchor.addEventListener("click", clickHandler);
    }
     
    function clickHandler(e) {
      e.preventDefault();
      const header = document.querySelector("header").offsetHeight;
      const href = this.getAttribute("href"); 
      const offsetTop = document.querySelector(href).offsetTop;

      document.body.classList.remove("menu-active");
     
      scroll({
        //top: offsetTop-header,
        top: offsetTop,
        behavior: "smooth"
      });
    }

    /*Anchor scroll nav*/
    const anchorsNav = document.querySelectorAll(".scroller > a");
     
    for (const anchorNav of anchorsNav) {
      anchorNav.addEventListener("click", clickHandlerNav);
    }
     
    function clickHandlerNav(e) {
      e.preventDefault();
      let header = document.querySelector("header").offsetHeight;
      let href = this.getAttribute("href"); 
      let split = href.split('#');
      let anchor = '#'+split[1];
      let offsetTop = document.querySelector(anchor).offsetTop;
      if (document.querySelector("header").classList.contains('-sticky')) {
        
      }else{
        header = header-79;
      }
      
      document.body.classList.remove("menu-active");
      
     
      scroll({
        top: offsetTop-header,
        /*top: offsetTop,*/
        behavior: "smooth"
      });
    } 


    /*Accordion*/
    $('[data-accordion]').click(function(e) {
        e.preventDefault();
        var parent = $(this).closest('.-accordion');
        /*var elParent = $(this).closest('.-accordion-item');*/

        //parent.find('.-accordion-item').removeClass('-active');

        if ( $(this).closest('.-accordion-item').hasClass('-active') ) {
            parent.find('.-accordion-item').removeClass('-active');
            $(this).closest('.-accordion-item').removeClass('-active');
        }else{
            parent.find('.-accordion-item').removeClass('-active');
            $(this).closest('.-accordion-item').addClass('-active');
        }
        
    });         
      

    /*Dropdown mobile*/
    $('.dropdown-toggle-hover').click(function(){
      
      if ($(window).width() < 1025) {
        event.preventDefault();
        var ddl = $(this).closest('.dropdown');
        ddl.toggleClass('open');
      }else{
        return;
      }
    });

    /*Tiny slider gallery*/
    const tnsSliderGallery = document.querySelectorAll('.-gallery-tns');
    tnsSliderGallery.forEach(sliderGallery => {
      const tnsSliderGallery = tns({
          container: sliderGallery,
          items: 1,
          nav: false,
          controls: true,
          autoplayButtonOutput: false,
          autoplay: false,
          autoplayTimeout: 4000,
          gutter: 0,
          loop: false,
          mouseDrag: false,
          controlsText: ['<span class="-prev"><iconify-icon icon="lucide:arrow-left"></iconify-icon></span>', '<span class="-next"><iconify-icon icon="lucide:arrow-right"></iconify-icon></span>'],
          controlsPosition: "bottom",
      });
    }); 

    /*Tiny slider testimonials*/
    const tnsSliderTestimonials = document.querySelectorAll('.-testimonials-tns');
    tnsSliderTestimonials.forEach(SliderTestimonials => {
      const tnsSliderTestimonials = tns({
          container: SliderTestimonials,
          items: 3,
          nav: false,
          controls: true,
          autoplayButtonOutput: false,
          autoplayHoverPause: true,
          autoplay: false,
          autoplayTimeout: 6000,
          gutter: 16,
          loop: false,
          mouseDrag: true,
          controlsPosition: "bottom",
          controlsText: ['<span class="-prev"><iconify-icon icon="lucide:arrow-left"></iconify-icon></span>', '<span class="-next"><iconify-icon icon="lucide:arrow-right"></iconify-icon></span>'],
          responsive: { 
              1366: {
                items: 3,
                autoplay: false,
                /*items: 2,
                nav: true,
                controls: false,*/
              },
              768: {
                items: 3,
                /*items: 2,
                nav: true,
                controls: false,*/
              },
              320: {
                /*loop: false,
                swipeAngle: false,
                items: 1.4,
                gutter: 24,*/
                items: 1,
                autoplay: true,
                //nav: true,
                //gutter: 0
                /*loop: true,
                */
                /*gutter: 0,*/
              }, 
          } 
      });
    });     


    // Submit com reCAPTCHA v3 + fetch (adaptado p/ terser)
    document.getElementById('contact-form').addEventListener('submit', function(e) {
      e.preventDefault();
      var form = e.currentTarget;
      var btn  = document.getElementById('send-btn');
      btn.disabled = true;

      grecaptcha.ready(function () {
        grecaptcha.execute('6LfQQ1QsAAAAAF2sQqqxfJnUMhOHS_QJ3izBjKRx', { action: 'contact' })
        .then(function (token) {
          document.getElementById('recaptcha_token').value = token;
          var data = new FormData(form);
          return fetch(form.action, { method: 'POST', body: data });
        })
        .then(function (res) {
          var ct = res.headers.get('content-type');
          var isJSON = ct && ct.indexOf('application/json') !== -1;

          if (isJSON) {
            return res.json().then(function (payload) {
              return { res: res, payload: payload };
            });
          } else {
            return res.text().then(function (html) {
              return { res: res, payload: { ok: res.ok, html: html } };
            });
          }
        })
        .then(function (pack) {
          var payload = pack.payload;
          console.log(pack)
          if (payload && payload.ok) {
            alert('Mensagem enviada com sucesso!');
            form.reset();
          } else {
            var msg = (payload && payload.error) ?
            payload.error :
            (payload && payload.errors ? payload.errors.join('\n') : 'Falha no envio.');
            alert(msg);
            //console.log(payload.errors)
          }
          btn.disabled = false; // reabilita no sucesso
        })
        .catch(function () {
          alert('Erro ao enviar. Tente novamente.');
          btn.disabled = false; // reabilita no erro
        });
      });
    });    

                 

     /*GDPR*/
    document.addEventListener('DOMContentLoaded', function() {
      var cookiebar = document.querySelector('.cookiebar');
      if (cookiebar) { 
          var closecookiebar = document.querySelector('.hide-cookiebar-target');
          var acceptcookie = document.querySelector('.accept-cookies');
          var refusecookie = document.querySelector('.refuse-cookies');
          var cookie = readCookie('gr_cookie_lgpd_consent');/*Name of cookie*/
          //console.log(cookie);

          if (cookie == "true") {
              cookiebar.style.display = "none";
          }else if (cookie == "false") {
              cookiebar.style.display = "none";
          }else{
              cookiebar.classList.add("no-cookie-yet");
          }

          acceptcookie.addEventListener('click', function(e) {
              if(cookie != "true") {
                cookiebar.style.display = "none";
                createCookie('gr_cookie_lgpd_consent', "true", 7);
              } 
              e.preventDefault();
          });

          if (refusecookie) {
            refusecookie.addEventListener('click', function(e) {
                if(cookie != "true") {
                  cookiebar.style.display = "none";
                  createCookie('gr_cookie_lgpd_consent', "false", 7);
                }
                e.preventDefault();
            });  
          }
          
          if (closecookiebar) {
            closecookiebar.addEventListener('click', function(e) {
                cookiebar.style.display = "none";
                /*if(cookie != "true") {
                  createCookie('gr_cookie_lgpd_consent', "true", 1);
                } */
                e.preventDefault();
            });
          }

      }

      function createCookie(name, value, days) {
          if(days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            var expires = "; expires=" + date.toGMTString();
          } else var expires = "";
          document.cookie = name + "=" + value + expires + "; path=/"
      }

      function readCookie(name) {
          var nameEQ = name + "=";
          var ca = document.cookie.split(';');
          for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
           
          }
          return null;
      }

      function eraseCookie(name) {
          createCookie(name, "", -1);
      }

    }); 

(function() {
  const wrap = document.querySelector('.hero-video-wrap');
  const playBtn = document.querySelector('.hero-video-play');
  let player;
  let isPlayerReady = false; // Flag para evitar o erro

  // 1. Carrega a API do YouTube
  const tag = document.createElement('script');
  tag.src = "https://www.youtube.com/iframe_api";
  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  // 2. Inicializa o Player
  window.onYouTubeIframeAPIReady = function() {
    player = new YT.Player('heroVideo', {
      videoId: 'R73nl9vDVkA',
      playerVars: {
        'autoplay': 0,
        'mute': 1,
        'controls': 0,
        'rel': 0,
        'showinfo': 0,
        'modestbranding': 1
      },
      events: {
        'onReady': () => { isPlayerReady = true; }, // Ativa a flag quando estiver pronto
        'onStateChange': onPlayerStateChange
      }
    });
  };

  // 3. Clique do Botão (Com proteção contra o erro)
  playBtn.addEventListener('click', () => {
    // Só executa se o player existir E os métodos estiverem disponíveis
    if (player && isPlayerReady && typeof player.getPlayerState === 'function') {
      const state = player.getPlayerState();

      if (state !== YT.PlayerState.PLAYING) {
        player.playVideo();
        player.unMute();
        wrap.classList.add('is-playing');
      } else {
        player.pauseVideo();
        wrap.classList.remove('is-playing');
      }
    } else {
      console.log("O player ainda está carregando...");
    }
  });

  function onPlayerStateChange(event) {
    if (event.data === YT.PlayerState.ENDED) {
      wrap.classList.remove('is-playing');
      player.seekTo(0);
      player.pauseVideo(); 
    }
  }
})();               

    var header = document.querySelectorAll(".dynamic-header");
    if (!header.length) { return; }
    var headerHeight = header[0].offsetHeight;
    window.onscroll = function() {
      //console.log(window.innerWidth)
        var scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
        var vh1o3 = (window.innerWidth/3);
        var vh1o2 = (window.innerWidth/2);
        var vhMin = 100;
        var vhMinWA = 200;
        /*if (scrollPosition > headerHeight && window.innerWidth > 992) {*/
        /*if (scrollPosition > headerHeight) {*/
        if (scrollPosition > vhMin) {
                header[0].classList.add('-sticky');
                
        }else{
                header[0].classList.remove('-sticky');
                
        }

        if (scrollPosition > vhMinWA) {
                
                document.body.classList.add("-has-sticky");
        }else{
                
                document.body.classList.remove("-has-sticky");
        }
    };

}(window.jQuery, window, document));